import { setWasmSource } from '@extend-ai/react-docx';

let configured = false;

/**
 * Points the Extend DOCX engine at the bundled WebAssembly binary. The
 * .wasm file ships in public/ (copied from the package dist) so it is
 * served same-origin without bundler config; this must run before the
 * first document parse. Safe to call repeatedly — only the first call
 * takes effect.
 */
export function ensureDocxWasmSource(): void {
  if (configured || typeof window === 'undefined') return;
  setWasmSource('/docx_wasm_bg.wasm');
  configured = true;
}
